import ArchiveWinnerCategory from './Main'

const route = {
  path: '/archive/winner/:year/:categoryName',
  name: 'winnerArchiveCategory',
  meta: {
    title: 'Archive - A D M A N 2 0 1 9'
  },
  component: ArchiveWinnerCategory
}

export default route
